import { render, staticRenderFns } from "./FixPart.vue?vue&type=template&id=53dcdba6&"
import script from "./FixPart.vue?vue&type=script&lang=js&"
export * from "./FixPart.vue?vue&type=script&lang=js&"
import style0 from "./FixPart.vue?vue&type=style&index=0&id=53dcdba6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports